import React, { FunctionComponent } from 'react';
import type { Props } from './types';

export const Presentation: FunctionComponent<Props> = ({ bannerImage }) => {
  return (
    <section className="sitetop-first-guide">
      <a href="https://www.readytofashion.jp/mag/first-guide/" className="sitetop-first-guide-link">
        <div className="sitetop-first-guide-link-content">
          <img src={bannerImage} alt="初めてガイドバナー" />
          <h2>
            <span className="company-name">READY TO FASHION</span>
            <br />
            を初めてご利用する方へ
          </h2>
        </div>
      </a>
    </section>
  );
};
